<dx-popup
    title="Dumpster Maintenance"
    [width]="400"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="maintenance" class="mb-4" validationGroup="mainValidationGroup">
        <dxi-form-item dataField="dueDate" editorType="dxDateBox"></dxi-form-item>
        <dxi-form-item dataField="note" editorType="dxTextArea" [editorOptions]="{ height: '125px' }" [isRequired]="true"></dxi-form-item>
        <dxi-form-item dataField="completed" editorType="dxDateBox"></dxi-form-item>
    </dx-form>
</dx-popup>
